import {
    MdCheckboxModule,
    MdButtonModule,
    MdRadioModule,
    MdIconModule,
    MdCardModule,
    MdTooltipModule,
    MdTableModule,
    MdTabsModule,
    MdListModule,
    MdToolbarModule,
    MdInputModule,
    MdOptionModule,
    MdSelectModule,
    MdProgressSpinnerModule,
    MdSlideToggleModule
} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/table';
import {BusyModule} from 'angular2-busy';
import {FlexLayoutModule} from '@angular/flex-layout';

export const MDModules = [
    MdCheckboxModule, MdButtonModule, MdRadioModule, MdIconModule, MdCardModule, MdTooltipModule,
    MdTableModule, CdkTableModule, MdTabsModule, MdListModule, MdToolbarModule, MdInputModule,
    MdListModule, MdOptionModule, MdSelectModule, MdProgressSpinnerModule, MdSlideToggleModule,
    BusyModule, FlexLayoutModule
];


// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/md-module-imports.ts